import { render, staticRenderFns } from "./ModalFaq.vue?vue&type=template&id=7d34a818&scoped=true"
import script from "./ModalFaq.vue?vue&type=script&lang=js"
export * from "./ModalFaq.vue?vue&type=script&lang=js"
import style0 from "./ModalFaq.vue?vue&type=style&index=0&id=7d34a818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d34a818",
  null
  
)

export default component.exports